import { IAttribute } from '@gn-audio/core/api/product-catalogue/models/attribute';
import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';
import { Component, Inject, Input, OnInit } from 'angular-ts-decorators';

import { ProductComparisonBaseComponent } from '../models/product-comparison-base.component';
import { IProductComparisonConfiguration } from '../models/product-comparison-configuration';

import { fetchConfiguration } from '../utils/fetch-configuration';

import template from './product-comparison-in-product-page.component.html';

@Component({
  selector: 'productComparisonInProductPage',
  template,
  transclude: {
    headline: '?productComparisonHeadline',
  },
})
export class ProductComparisonInProductPageComponent extends ProductComparisonBaseComponent implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$q'];

  @Input('@') public configurationId?: string;
  @Input('@') public pageId?: string;

  public configuration?: IProductComparisonConfiguration;
  public leftProductsDisabled = false;
  public leftProducts: IFamily[] = [];
  public leftSelectedProduct?: IFamily;
  public rightProducts: IFamily[] = [];
  public rightSelectedProduct?: IFamily;
  public selectedProducts?: IFamily[];
  public selectedProductsAttributes?: IAttribute[][];

  constructor(@Inject('$q') $q: ng.IQService) {
    super($q);
  }

  public ngOnInit() {
    this.$q.when(fetchConfiguration(this.configurationId, this.pageId))
      .then(this.onConfigurationLoaded.bind(this), this.stopLoading);
  }

  public onLeftProductChange(product: IFamily) {
    this.leftSelectedProduct = product;
    if (!this.leftProductsDisabled) {
      this.rightProducts = this.products.filter((x: IFamily) => x.familyId !== this.leftSelectedProduct.familyId);
    }

    this.reCalculateAttributes();
  }

  public onRightProductChange(product: IFamily) {
    this.rightSelectedProduct = product;
    if (!this.leftProductsDisabled) {
      this.leftProducts = this.products.filter((x: IFamily) => x.familyId !== this.rightSelectedProduct.familyId);
    }

    this.reCalculateAttributes();
  }

  private onConfigurationLoaded(configuration: IProductComparisonConfiguration) {
    this.configuration = configuration;
    const { contextFamilyId, familyIds } = this.configuration;
    if (!!contextFamilyId && familyIds?.indexOf(contextFamilyId) === -1) {
      familyIds.push(contextFamilyId);
    }

    if (familyIds?.length === 0) {
      this.stopLoading();
      return;
    }

    this.setFemilies(familyIds)
      .then(this.getAttributes.bind(this), this.stopLoading)
      .then(this.getSegmentTypeConfiguration.bind(this), this.stopLoading)
      .then(this.onFamiliesLoaded.bind(this), this.stopLoading)
      .finally(this.stopLoading);
  }

  private onFamiliesLoaded(families: IFamily[] | null) {
    const { contextFamilyId } = this.configuration;
    if (contextFamilyId) {
      this.leftProductsDisabled = true;
      this.leftProducts = families.filter((x: IFamily) => x.familyId === contextFamilyId);
      this.leftSelectedProduct = this.leftProducts[0];
      this.rightProducts = families.filter((x: IFamily) => x.familyId !== contextFamilyId);
      this.rightSelectedProduct = this.rightProducts[0];
    } else {
      this.leftSelectedProduct = families[0];
      this.rightSelectedProduct = families[1];
      this.leftProducts = families.filter((x: IFamily) => x.familyId !== this.rightSelectedProduct.familyId);
      this.rightProducts = families.filter((x: IFamily) => x.familyId !== this.leftSelectedProduct.familyId);
    }

    this.reCalculateAttributes();
  }

  private reCalculateAttributes() {
    this.selectedProducts = [this.leftSelectedProduct, this.rightSelectedProduct];
    this.selectedProductsAttributes = [];
    this.selectedProducts.forEach((product: IFamily) => {
      const reducedAttributes = this.attributes[String(product.familyId)]?.map((f: IProductWithAttributes) => f.attributes)
        .reduce((a: IAttribute[], b: IAttribute[]) => Array.prototype.concat.apply(a, b));
      this.selectedProductsAttributes.push(reducedAttributes);
    });
  }
}
